export default __webpack_public_path__ + "static/icons/icon-mid-mountain-e671eaebf1548861640c7655c501ec3d.png";